import ResourceCards from './ResourceCards'

export default ResourceCards
